
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[ssgParams]/privacy",
      function () {
        return require("private-next-pages/[ssgParams]/privacy/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[ssgParams]/privacy"])
      });
    }
  